// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/city-landscape.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_wrapper {
  height: 35vh;
  background: #d6e5f9;
  position: relative;
  overflow: hidden;
}
.truck_icon {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  height: 70px;
}
.footer_overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 0;
  z-index: 1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  object-fit: cover;
  background-position: center bottom;
}

.footer_bottom_section {
  background: linear-gradient(0deg, #307fe2, #307fe2);
}
.footer_container {
  width: 90%;
  margin: 0 auto;
  padding: 10px 0 5px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.white_line {
  height: 1px;
  background: white;
  width: 100%;
}
.footer_logo {
  width: 150px;
}
.footer_container p {
  text-align: center;
  margin: 0;
  font-family: sans-serif;
  color: white;
}
@media screen and (max-width: 700px) {
  .footer_container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FooterSection/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,UAAU;EACV,UAAU;EACV,yDAAyD;EACzD,4BAA4B;EAC5B,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,mDAAmD;AACrD;AACA;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":[".footer_wrapper {\r\n  height: 35vh;\r\n  background: #d6e5f9;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n.truck_icon {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 2;\r\n  height: 70px;\r\n}\r\n.footer_overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: 0;\r\n  z-index: 1;\r\n  background-image: url(\"../../images/city-landscape.webp\");\r\n  background-repeat: no-repeat;\r\n  object-fit: cover;\r\n  background-position: center bottom;\r\n}\r\n\r\n.footer_bottom_section {\r\n  background: linear-gradient(0deg, #307fe2, #307fe2);\r\n}\r\n.footer_container {\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  padding: 10px 0 5px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n.white_line {\r\n  height: 1px;\r\n  background: white;\r\n  width: 100%;\r\n}\r\n.footer_logo {\r\n  width: 150px;\r\n}\r\n.footer_container p {\r\n  text-align: center;\r\n  margin: 0;\r\n  font-family: sans-serif;\r\n  color: white;\r\n}\r\n@media screen and (max-width: 700px) {\r\n  .footer_container {\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
